import { render, staticRenderFns } from "./LoadingWheel.vue?vue&type=template&id=e77454d6&scoped=true&"
import script from "./LoadingWheel.vue?vue&type=script&lang=js&"
export * from "./LoadingWheel.vue?vue&type=script&lang=js&"
import style0 from "./LoadingWheel.vue?vue&type=style&index=0&id=e77454d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77454d6",
  null
  
)

export default component.exports